import React from 'react'
import withServices from '../../hocs/withServices'
import { Box, Button, Container, Typography } from '@material-ui/core'
import useFetchData from '../../hooks/useFetchData'

const ContractPage = ({ services }) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const contractData = React.useCallback(() => services.contract.getContract(), []);
    const { data: contract } = useFetchData(contractData, true);



    return (
        <Container component="main" maxWidth="xl">
            <Typography variant="h5">Данные договора поступающим</Typography>
            <Typography style={{marginTop: "20px"}}>Для подписания договора необходимо перейти по ссылке</Typography>
            <br />
            {contract && (
                <>
                    <Typography variant="h6">Номер договора: {contract.podpishiDocNum}</Typography>

                    <Box style={{ width: "100%", display: "flex", "flexDirection": "row" }}>
                        <Typography variant="h6">Ссылка для подписи договора:  </Typography>
                        <Button variant="contained" target="_blank" style={{ marginLeft: "10px" }} color="primary" href={`https://api.podpishi.kz/qr.php?id1=${contract.podpishiDocNum}&id2=${contract.podpishiDocHash}`}>Подписать договор</Button>
                    </Box>
                </>
            )}
        </Container>
    )
}

export default withServices()(ContractPage)